export default "__VITE_ASSET__27a560f4__"